import { createFileRoute } from '@tanstack/react-router';
import { OrderDetail } from '@/features/coordination-orders/OrderDetail';

export const Route = createFileRoute('/_shell/orders/$orderId')({
  component: OrderDetailRoute,
});

function OrderDetailRoute() {
  const { orderId } = Route.useParams();
  return <OrderDetail orderId={orderId} />;
}
